<template>
  <el-dialog title="设置数值区间" width="700px" class="cellDialog table-prize" :visible.sync="visible" @close="handleClose"
    @open="handleOpen">

    <el-form :inline="true" :model="formInline" class="analyse-setting-value-main">
      <el-form-item v-for="item in formInline.sectionList" :key="item.index">
        <div class="analyse-setting-section">
          <span class="title">区间：</span>
          <el-input disabled v-model="item.minValue" class="analyse-setting-section-input"
            :value="item.minValue=== '+∞'?'':item.minValue"></el-input>

          <span>&nbsp;&nbsp;&nbsp;&lt;&nbsp;&nbsp;&nbsp;数值&nbsp;&nbsp;&nbsp;&lt;=&nbsp;&nbsp;&nbsp;</span>
          <span class="first-value" v-if="item.showSymbol">+∞</span>
          <el-input v-model="item.maxValue" v-else class="analyse-setting-section-input"
            @input="handleInputChange($event,item.index)" @blur="blurClick($event,item.index)" type="number"></el-input>
          <span class="title">区间名称：</span>
          <el-input v-model="item.name" maxlength="20" class="analyse-setting-section-input"></el-input>
          <div v-show="item.disabled && formInline.sectionList.length>1 " class="close-btn"
            @click="handleDeleteSection(item.index)">
            ×
          </div>
        </div>
      </el-form-item>
      <div v-show="formInline.sectionList.length < 8" class="add-section" @click="handleAddSection">
        ＋增加区间
      </div>

    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose" class="dialog-footer-cancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'SettingValueDialog',
  props: {
    visible: Boolean,
    sectionFormLine: {
      type: Object,
      default () {
        return {
          sectionList: [{
            minValue: '-∞',
            maxValue: '',
            name: '',
            disabled: false, // 控制是否展示删除按钮
            showSymbol: true, // 控制是否展示+∞
            index: 0
          }],
        }
      }
    }
  },

  data () {
    return {
      formInline: {
        sectionList: [{
          minValue: '-∞',
          maxValue: '',
          name: '',
          disabled: false, // 控制是否展示删除按钮
          showSymbol: true, // 控制是否展示+∞
          index: 0
        }]
      },
      inputs: '',
      ltValue: '',
      gtValue: '',
      equlValue: ''
    }
  },

  watch: {
    visible: {
      handler (val) {
        return val
      },
      deep: true,
      immediate: true
    },
    sectionFormLine: {
      handler (val) {
        this.$nextTick(() => {
          this.formInline = JSON.parse(JSON.stringify(val))
        })
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    // 监听input框中
    handleInputChange (currentValue, index) {
      this.inputs = currentValue
      // if (currentValue) {
      //   const reg = /(^[\-0-9][0-9]*(.[0-9]+)?)$/
      //   const judge = new RegExp(reg)
      //   if (!judge.test(currentValue)) {
      //     this.$message.error('请输入数值')
      //     return
      //   }
      // }
      // if (index > 0) {
      //   // 先判断当前输入框中的值是否大于前面的值 正数时
      //   const preValue = this.formInline.sectionList[index - 1].maxValue
      //   if (currentValue > 0 && Math.abs(currentValue) < Math.abs(preValue)) {
      //     this.$message.error('输入的值要大于前面的值')
      //     return
      //   }
      //   // 负数时
      //   if (currentValue < 0 && Math.abs(currentValue) > Math.abs(preValue)) {
      //     this.$message.error('输入的值要大于前面的值')
      //     return
      //   }
      // }
      // 让下一行的最小值变成当前输入框中的值
      this.formInline.sectionList[index + 1].minValue = currentValue
    },
    blurClick (currentValue, index) {
      if (this.inputs) {
        const reg = /(^[\-0-9][0-9]*(.[0-9]+)?)$/
        const judge = new RegExp(reg)
        if (!judge.test(this.inputs)) {
          this.$message.error('请输入数值')
          this.equlValue = 'empty'
          return
        }
      }
      if (index > 0) {
        // 先判断当前输入框中的值是否大于前面的值 正数时
        const preValue = this.formInline.sectionList[index - 1].maxValue
        if (this.inputs > 0 && Math.abs(this.inputs) < Math.abs(preValue)) {
          this.$message.error('输入的值要大于前面的值')
          this.equlValue = 'gt'
          return
        } else if (this.inputs < 0 && Math.abs(this.inputs) > Math.abs(preValue)) { // 负数时
          this.$message.error('输入的值要大于前面的值')
          this.equlValue = 'lt'
          return
        } else if (this.inputs == 0 && Math.abs(this.inputs) < Math.abs(preValue)) { // 为0时
          this.$message.error('输入的值要大于前面的值')
          this.equlValue = 'equlValue'
          return
        } else {
          this.equlValue = ''
        }
      }
    },

    // 关闭弹窗
    handleClose (done) {
      this.$emit('handleSeetingVisible')
    },

    // 打开弹窗 时
    handleOpen () { },

    // 增加区间
    handleAddSection () {
      // 让前面的删除按钮+∞隐藏掉
      this.formInline.sectionList.forEach(ele => {
        ele.disabled = false
        ele.showSymbol = false
      })
      const sectionList = JSON.parse(JSON.stringify(this.formInline.sectionList))
      const index = sectionList.length
      const maxValue = this.formInline.sectionList[0].maxValue
      this.formInline.sectionList[0].maxValue = maxValue === '+∞' ? '' : maxValue
      this.formInline.sectionList[index - 1].maxValue = ''
      this.formInline.sectionList.push({
        minValue: '',
        maxValue: '',
        name: '',
        disabled: true,
        showSymbol: true,
        index: sectionList.length
      })
    },

    // 删除区间
    handleDeleteSection (index) {
      this.formInline.sectionList.splice(index, 1)
      // 控制是否展示删除按钮 上一个变为展示
      this.formInline.sectionList[index - 1].disabled = true
      // 控制是否展示+∞ 上一个变为展示+∞
      this.formInline.sectionList[index - 1].showSymbol = true
      // 上一个的最大值变成+∞
      this.formInline.sectionList[index - 1].maxValue = '+∞'
    },

    // 提交
    handleSubmit () {
      if (this.equlValue == 'empty') {
        this.$message.error('请输入数值')
        return
      } else if (this.equlValue == 'gt' || this.equlValue == 'lt' || this.equlValue == 'equlValue') {
        this.$message.error('输入的值要大于前面的值')
        return
      }
      const nameList = this.formInline.sectionList.map(item => item.name)
      // [...new Set(nameList)]能去重但是不能去掉空串
      let newNameList = [...new Set(nameList)]
      // filter去掉空串
      newNameList = newNameList.filter(item => item !== '')
      // 弹窗中区间数组的长度
      const sectionListLen = this.formInline.sectionList.length
      // 去重去掉空串后的区间名称的长度
      const newNameListLen = newNameList.length
      // 比较两个长度
      if (sectionListLen > newNameListLen) {
        this.$message.error('区间名称不能有相同的且不能为空')
        return
      }
      // 判断数值不能为空
      const maxValueList = this.formInline.sectionList.filter(item => item.maxValue !== '')
      const maxValueLen = maxValueList.length
      if (sectionListLen - 1 > maxValueLen) {
        this.$message.error('区间数值不能为空')
        return
      }
      this.$emit('handleSectionSubmit', this.formInline.sectionList)
    },
  }
}
</script>
<style lang="css" scoped>
.analyse-setting-value-main {
  padding: 20px 0;
}
.analyse-setting-section {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.analyse-setting-section .title {
  margin-left: 20px;
}

.analyse-setting-section .first-value {
  font-size: 20px;
  width: 120px;
}
.analyse-setting-section .value {
  margin-left: 10px;
}

.close-btn {
  margin-left: 10px;
  font-size: 20px;
  cursor: pointer;
}
.add-section {
  text-align: center;
  font-weight: bold;
  width: 100px;
  margin: 0 auto;
  cursor: pointer;
}
</style>
